var exports = {
  "m": "BaseChangeNicknameModal.module__clearButton___MFhBVV",
};

module.exports = exports;
